import { render, staticRenderFns } from "./PhoneListComponent.vue?vue&type=template&id=6136cec6&scoped=true"
import script from "./PhoneListComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhoneListComponent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PhoneListComponent.vue?vue&type=style&index=0&id=6136cec6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6136cec6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6136cec6')) {
      api.createRecord('6136cec6', component.options)
    } else {
      api.reload('6136cec6', component.options)
    }
    module.hot.accept("./PhoneListComponent.vue?vue&type=template&id=6136cec6&scoped=true", function () {
      api.rerender('6136cec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widgets/ExpedientWidgets/ExpedientSummaryWidget/PhoneListComponent.vue"
export default component.exports